import { coerce, eq, prerelease } from "semver";

export default function satisfies(versionA: string, versionB: string): boolean {
    // Handshake: major.minor.patch должны совпасть (prerelease — тоже строго).
    const coercedA = coerce(versionA);
    const coercedB = coerce(versionB);
    if (!coercedA || !coercedB) {
        return false;
    }
    if (prerelease(versionA) && prerelease(versionB)) {
        return eq(coercedA, coercedB);
    }
    return eq(coercedA, coercedB);
}
